export function setSwitcher(switcher) {
    localStorage.setItem('switcher', JSON.stringify(switcher));
}
export function getSwitcher() {
    const switcher = JSON.parse(localStorage.getItem(`switcher`));
    return switcher;
}
export function setAmmochosen(ammo, shootType) {
    localStorage.setItem(`${shootType}`, JSON.stringify(ammo));
}
export function currentAmmochosen(shootType) {
    const ammo = JSON.parse(localStorage.getItem(`${shootType}`));
    return ammo;
}